import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './i18n';
import App from './App.tsx';
import './index.css';
import './styles/osworks-ds/components.css';
import './styles/osworks-ds/painel.css';
import { initAnalytics } from './lib/analytics';
import { initSentry } from './lib/sentry';
import { registerServiceWorker } from './lib/pwa';
import { SentryFallback } from './components/SentryFallback';

initSentry();
initAnalytics();
registerServiceWorker();

createRoot(document.getElementById('root')!).render(
  <Sentry.ErrorBoundary fallback={<SentryFallback />}>
    <App />
  </Sentry.ErrorBoundary>,
);
